import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FaqPage() {
  const faqs = [{
    question: 'What is MCPGuard?',
    answer: 'MCPGuard is a security plane for enterprise agentic AI. It acts as a context firewall between your AI agents and your traditional data stores, enforcing real-time deterministic delegated authority and providing full auditability for every action an AI takes.'
  }, {
    question: 'How does delegated authorization work?',
    answer: "MCPGuard assesses human and AI access entitlements separately. When an AI agent attempts an action on behalf of a user, MCPGuard verifies both the user's permissions and the AI's permissions before issuing ephemeral access tokens to complete the request."
  }, {
    question: 'How is data protected before it reaches the AI?',
    answer: 'MCPGuard applies ingress and egress rules to data and toolchains. This includes real-time data redaction, tokenization, and anonymization. Data label access rules are enforced before the data ever leaves your traditional data store.'
  }, {
    question: 'What kind of audit trail does MCPGuard provide?',
    answer: 'MCPGuard provides full chain auditability. For every action, it records: Who requested it (the human), who executed it (the AI agent), what was accessed (the data source), why it was allowed (the policy decision), and exactly what data was returned.'
  }, {
    question: 'What are the deployment options?',
    answer: 'MCPGuard is designed for highly regulated environments and offers flexible deployment options. You can deploy it in the cloud, on-premise, or in a hybrid configuration depending on your security and compliance requirements.'
  }, {
    question: 'How do I get started?',
    answer: 'MCPGuard is currently in private preview. You can join our waiting list to request early access, and our team will reach out to discuss your specific use case and deployment needs.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto py-12 px-4 animate-in fade-in duration-500" data-id="element-197">
      <div className="text-center mb-12" data-id="element-198">
        <h1 className="text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-199">
          Frequently Asked Questions
        </h1>
        <p className="text-xl text-gray-600" data-id="element-200">
          Everything you need to know about securing agentic AI with MCPGuard.
        </p>
      </div>

      <div className="space-y-4" data-id="element-201">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={index} className={`border rounded-lg overflow-hidden transition-colors ${isOpen ? 'border-[#4db8a4] bg-white' : 'border-gray-200 bg-gray-50 hover:bg-white'}`} data-id="element-202">
              <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-203">
                <span className={`text-lg font-bold ${isOpen ? 'text-[#4db8a4]' : 'text-[#1e3a5f]'}`} data-id="element-204">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'transform rotate-180 text-[#4db8a4]' : 'text-gray-400'}`} data-id="element-205" />
              </button>

              {isOpen && <div className="px-6 pb-5 animate-in slide-in-from-top-2 duration-200" data-id="element-206">
                  <p className="text-gray-600 leading-relaxed" data-id="element-207">{faq.answer}</p>
                </div>}
            </div>;
      })}
      </div>
    </div>;
}